module.exports = __webpack_public_path__ + "static/img/15.f2a9b4a5.png";